'use es6';

import { jsxs as _jsxs } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
import { PureComponent } from 'react';
import classNames from 'classnames';
import emptyFunction from 'react-utils/emptyFunction';
import PropTypes from 'prop-types';
import UIDragHandleHoverContainer from 'UIComponents/draggable/UIDragHandleHoverContainer';
import UIFlex from 'UIComponents/layout/UIFlex';
import UILink from 'UIComponents/link/UILink';
import UIBreakString from 'UIComponents/text/UIBreakString';
import { FilePropTypes } from 'DesignData/propTypes/finder';
import DragHandle from 'DesignFinderUI/components/dnd/DragHandle';
import FolderNavRenameInput from 'DesignFinderUI/components/nav/FolderNavRenameInput';
import { hasShiftKey, hasCommandKey } from 'DesignData/enums/Keys';
export default class FolderNavItemLink extends PureComponent {
  constructor(...args) {
    super(...args);

    this.onClick = evt => {
      const {
        onClick,
        pushRoute,
        to
      } = this.props;
      onClick(evt);

      if (!(hasCommandKey(evt) || hasShiftKey(evt))) {
        pushRoute(to);
      }
    };
  }

  renderRenameInput() {
    const {
      fileType,
      isRenameConfirmPending,
      name,
      onRenameCancel,
      onRenameSubmit,
      isServerlessFunctionFolder
    } = this.props;
    return /*#__PURE__*/_jsx(FolderNavRenameInput, {
      excludeExtension: true,
      fileType: fileType,
      isConfirmPending: isRenameConfirmPending,
      onCancel: onRenameCancel,
      onSubmit: onRenameSubmit,
      validateDefaultValue: true,
      value: name,
      isServerlessFunctionFolder: isServerlessFunctionFolder
    });
  }

  render() {
    if (!this.props.asLink) {
      return null;
    }

    const {
      canDrag,
      canRename,
      children,
      className,
      extraChildren,
      isRenameActive,
      linkComponent
    } = this.props;
    const [renderedIcon, __renderedTitle, ...rest] = children;
    const linkClasses = classNames('nav-item-link', className);
    const LinkComponent = isRenameActive ? 'div' : linkComponent;
    const renderedDragHandle = canDrag && !isRenameActive ? /*#__PURE__*/_jsx(DragHandle, {}) : null;
    const renderedTitle = canRename && isRenameActive ? this.renderRenameInput() : /*#__PURE__*/_jsx(UIBreakString, {
      children: __renderedTitle
    });
    return /*#__PURE__*/_jsx(UIDragHandleHoverContainer, {
      children: /*#__PURE__*/_jsxs(LinkComponent, {
        "data-finder-node-name": this.props['data-finder-node-name'],
        "data-finder-node-id": this.props['data-finder-node-id'],
        "data-test-path": this.props['data-test-path'],
        "data-test-folder-open": this.props['data-test-folder-open'],
        "data-test-id": this.props['data-test-id'],
        onMouseEnter: this.props.onMouseEnter,
        onFocus: this.props.onFocus,
        onClick: this.onClick,
        to: this.props.to,
        className: linkClasses,
        children: [/*#__PURE__*/_jsxs(UIFlex, {
          align: "start",
          children: [renderedDragHandle, renderedIcon, renderedTitle, rest]
        }), extraChildren]
      })
    });
  }

}
FolderNavItemLink.propTypes = {
  asLink: PropTypes.bool,
  canDrag: PropTypes.bool,
  canRename: PropTypes.bool,
  children: PropTypes.arrayOf(PropTypes.node).isRequired,
  className: PropTypes.string,
  extraChildren: PropTypes.node,
  fileType: FilePropTypes.fileType,
  isRenameActive: PropTypes.bool,
  isRenameConfirmPending: PropTypes.bool,
  isServerlessFunctionFolder: PropTypes.bool,
  linkComponent: PropTypes.oneOfType([PropTypes.func, PropTypes.string]),
  name: PropTypes.string.isRequired,
  onRenameCancel: PropTypes.func,
  onRenameSubmit: PropTypes.func,
  pushRoute: PropTypes.func.isRequired,
  onMouseEnter: PropTypes.func,
  onFocus: PropTypes.func,
  // TODO: Verify that these are needed.
  onClick: PropTypes.func,
  to: PropTypes.string,
  'data-test-id': PropTypes.string,
  'data-test-path': PropTypes.string,
  'data-test-folder-open': PropTypes.string,
  'data-finder-node-id': FilePropTypes.fileId,
  'data-finder-node-name': FilePropTypes.fileName
};
FolderNavItemLink.defaultProps = {
  asLink: true,
  canDrag: false,
  canRename: false,
  extraChildren: null,
  isRenameActive: false,
  isRenameConfirmPending: false,
  linkComponent: UILink,
  onRenameCancel: emptyFunction,
  onRenameSubmit: emptyFunction,
  pushRoute: emptyFunction
};